import React from 'react';
import NavBarPublic from '../NavBarPublic';
import Footer from '../Footer';
import { Outlet } from 'react-router-dom';

/**
 * Layout component for public pages
 * Includes the public navigation bar and common elements
 */
const PublicLayout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <NavBarPublic />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
